import { __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
export function getOrganizationLocations(signedInstance, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response, locations, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpClient.get("https://manage.wix.com/_api/restaurants/v2.1/settings/locations", {
                            headers: {
                                authorization: signedInstance,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    locations = response.data.locations;
                    return [2 /*return*/, {
                            locations: locations || [],
                        }];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, { locations: [] }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=locations.js.map